import $ from 'cash-dom'
import { slideClosed, slideOpen } from '../utilities/animations'
import { segment } from '../tracking/segment'

$(document).on(
  'click',
  '[data-action="toggle-expandable-content"], [data-action="toggle-expandable-button"]',
  function (e) {
    e.preventDefault()

    const clickedElement = $(this)
    const isButton = clickedElement.is(
      '[data-action="toggle-expandable-button"]'
    )
    const component = clickedElement.closest(
      '[data-component="expandable-content"]'
    )
    const content = component.find('[data-element="expandable-content"]')
    const eventName = component.attr('data-event-name')

    const expandedElement = isButton ? clickedElement : component
    const isExpanded = expandedElement.attr('aria-expanded') === 'true'

    expandedElement.attr('aria-expanded', !isExpanded)

    if (isExpanded) {
      slideClosed(content[0])
    } else {
      slideOpen(content[0])
    }

    if (eventName && eventName !== 'undefined') {
      segment?.track(`${eventName} clicked`)
    }
  }
)
